var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJustificacaoFaltas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "justificacao-faltas",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 171 171",
    style: {
      enableBackground: "new 0 0 171 171"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DD5100;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "justificacao-faltas_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tB5REx.tif_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.6,51.8c0.1-0.5,0.3-1,0.4-1.5c1.3-5.5,6.1-9.4,11.8-9.5c1.7,0,3.4,0,5.1,0c0-2.8,0-5.4,0-8.2 c2.8,0,5.5,0,8.3,0c0,2.7,0,5.4,0,8.1c18.2,0,36.3,0,54.4,0c0-2.7,0-5.4,0-8.1c2.8,0,5.5,0,8.3,0c0,2.7,0,5.4,0,8.2 c1.8,0,3.4,0,5.1,0c4.6,0.1,8.2,2.2,10.6,6.2c1.1,1.9,1.7,3.9,1.7,6.1c0,10.1,0,20.1,0,30.2c0,0.1,0,0.3,0,0.5 c-2.7,0-5.4,0-8.2,0c0-4.1,0-8.2,0-12.4c-29.7,0-59.4,0-89.1,0c0,0.3-0.1,0.6-0.1,0.9c0,17.5,0,35,0,52.5c0,3.5,1.5,5.1,5.1,5.1 c10,0,20,0,30,0c0.4,0,0.7,0,1.2,0c0,2.8,0,5.4,0,8.2c-0.4,0-0.8,0.1-1.2,0.1c-10,0-20,0-30,0c-7.2,0-11.8-3.8-13.2-10.8 c0-0.1-0.1-0.2-0.1-0.3C32.6,102,32.6,76.9,32.6,51.8z M40.9,63.1c29.8,0,59.4,0,89.1,0c0-3.4,0-6.6,0-9.9c0-2-1.4-3.7-3.2-3.9 c-1.9-0.2-3.8,0-5.8,0c0,2.7,0,5.4,0,8.1c-2.8,0-5.5,0-8.3,0c0-2.8,0-5.4,0-8.1c-18.2,0-36.3,0-54.4,0c0,2.7,0,5.4,0,8.1 c-2.8,0-5.4,0-8.2,0c0-2.7,0-5.4,0-8.1c-0.2-0.1-0.3-0.1-0.4-0.1c-1.6,0-3.1,0-4.7,0c-2.2,0.1-3.9,1.6-4,3.8 C40.9,56.3,40.9,59.6,40.9,63.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.2,138.4c1.4-6.2,2.9-12.5,4.3-18.7c0.6-2.6,1.9-4.9,3.8-6.8c9.1-9.4,18.2-18.7,27.3-28.1 c0.1-0.1,0.2-0.2,0.3-0.3c5.8,5.9,11.6,11.7,17.5,17.6c-0.2,0.2-0.4,0.4-0.7,0.7c-8.5,8.7-17,17.4-25.4,26.1 c-2.9,3.1-6.2,5-10.4,5.8c-5.3,1-10.6,2.3-15.8,3.5c-0.2,0-0.3,0.1-0.5,0.2C85.5,138.4,85.3,138.4,85.2,138.4z M121,96.2 c-7.4,7.6-14.9,15.3-22.2,22.8c2,2,3.9,3.9,5.8,5.9c7.4-7.6,14.8-15.3,22.2-22.9C124.9,100.2,123,98.2,121,96.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.6,80.1c0,2.7,0,5.4,0,8.1c-2.7,0-5.4,0-8.2,0c0-2.7,0-5.4,0-8.1C51.1,80.1,53.8,80.1,56.6,80.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.6,104.8c-2.8,0-5.4,0-8.2,0c0-2.7,0-5.4,0-8.1c2.7,0,5.4,0,8.2,0C56.6,99.2,56.6,102,56.6,104.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.1,96.6c0,2.7,0,5.4,0,8.1c-2.7,0-5.4,0-8.1,0c0-2.7,0-5.4,0-8.1C67.6,96.6,70.3,96.6,73.1,96.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.6,113.1c0,2.7,0,5.4,0,8.1c-2.7,0-5.4,0-8.2,0c0-2.7,0-5.4,0-8.1C51.1,113.1,53.8,113.1,56.6,113.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.1,113.1c0,2.8,0,5.4,0,8.1c-2.7,0-5.4,0-8.1,0c0-2.7,0-5.4,0-8.1C67.6,113.1,70.3,113.1,73.1,113.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.1,88.2c-2.8,0-5.4,0-8.1,0c0-2.7,0-5.4,0-8.2c2.7,0,5.4,0,8.1,0C73.1,82.8,73.1,85.5,73.1,88.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.5,88.2c-2.7,0-5.4,0-8.1,0c0-2.7,0-5.4,0-8.1c2.7,0,5.4,0,8.1,0C89.5,82.8,89.5,85.5,89.5,88.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106,88.2c-2.7,0-5.4,0-8.1,0c0-2.7,0-5.4,0-8.1c2.7,0,5.3,0,8.1,0C106,82.8,106,85.5,106,88.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.5,104.8c-2.7,0-5.4,0-8.1,0c0-2.7,0-5.4,0-8.2c2.7,0,5.4,0,8.1,0C89.5,99.2,89.5,102,89.5,104.8z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJustificacaoFaltas);
export default __webpack_public_path__ + "static/media/justificacao-faltas.2fc6afea6a04ec5a89feb435ff6fbd6c.svg";
export { ForwardRef as ReactComponent };